const { map, get, join } = require('lodash');

class ValidationError extends Error {

    constructor(errors) {

        const message = getMessage(errors);

        super(message);

        this.name = "ValidationError";
    }

    toJSON() {

        return {
            message: this.message
        }
    }
}

function getMessage(errors) {

    const messages = map(errors, (error, index) => {

        const dataPath = get(error, 'dataPath');
        const params = JSON.stringify(get(error, 'params'));
        const message = get(error, 'message');

        return `${index + 1}: The field at path "${dataPath}", with params "${params}", gave the message: "${message}"`;
    });

    const message = `Validation Errors:\n${join(messages, '\n')}`;

    return message;
}

module.exports = {
    ValidationError
}